/** Dot colors match SegmentedRatioBar (pmw-bar-blue / pmw-bar-orange). */
export interface MatchLabelsProps {
  /** Home team display name. */
  homeName: string;
  /** Away team display name. */
  awayName: string;
  /** Optional className for the container. */
  className?: string;
}

export default function MatchLabels({ homeName, awayName, className }: MatchLabelsProps) {
  return (
    <div className={`flex items-center justify-between w-full max-w-full ${className ?? ''}`}>
      <div className="flex gap-[4px] items-center min-w-0 max-w-[50%]">
        <span
          className="size-[8px] shrink-0 rounded-full bg-pmw-bar-blue-light dark:bg-pmw-bar-blue-dark"
          aria-hidden
        />
        <span className="font-robotoRegular text-[10px] leading-4 text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark truncate min-w-0">
          {homeName}
        </span>
      </div>
      <div className="flex gap-[4px] items-center justify-end min-w-0 max-w-[50%]">
        <span className="font-robotoRegular text-[10px] leading-4 text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark truncate min-w-0">
          {awayName}
        </span>
        <span
          className="size-[8px] shrink-0 rounded-full bg-pmw-bar-orange-light dark:bg-pmw-bar-orange-dark"
          aria-hidden
        />
      </div>
    </div>
  );
}
